// Algorithm for calculating reference number
export default function calculateReferenceNumber(orderNumber, separator = '') {
  let referenceNumber = null;
  let sum = 0;
  let checkDigit = 0;

  const baseValue = orderNumber;

  const reversedBaseValue = baseValue.split('').reverse().join('');

  for (let i = 0; i < reversedBaseValue.length; i++) {
    sum += reversedBaseValue.substring(i, i + 1) * (i + 2);
  }

  const remainder = sum % 11;

  switch (remainder) {
    case 0:
    case 1:
      referenceNumber = `${baseValue}${separator}0`;
      break;
    default:
      checkDigit = 11 - remainder;
      referenceNumber = `${baseValue}${separator}${checkDigit}`;
      break;
  }

  return referenceNumber;
}
